import { reqGet, TArrayItemsCallback } from 'HttpRequests'
import { IOffice } from './IOffice'

function reqGetOffices(callbak: TArrayItemsCallback<IOffice>) {
  reqGet('api/get_offices/', callbak)
}

export { reqGetOffices }
